import classes from "./FrontPage.module.css";

// component for front page of recipe book
const FrontPage = (props) => {
  return (
    <div
      className={classes.front_page}
      style={{ backgroundColor: ` ${props.colour}` }}
    >
      <div className={classes.top_img_container}>
        <img
          className={classes.top_decoration}
          src={"/assets/decorations/decoration_2.svg"}
          alt="new"
        />
      </div>
      <div className={classes.title}>{props.title}</div>
      <div className={classes.bottom_img_container}>
        <img
          className={classes.bottom_decoration}
          src={"/assets/decorations/decoration_2.svg"}
          alt="new"
        />
      </div>
    </div>
  );
};

export default FrontPage;
